export default "__VITE_ASSET__55gVVr7B__"